import { render, staticRenderFns } from "./HotspotMenu.vue?vue&type=template&id=f64b36fa&scoped=true"
import script from "./HotspotMenu.vue?vue&type=script&lang=ts"
export * from "./HotspotMenu.vue?vue&type=script&lang=ts"
import style0 from "./HotspotMenu.vue?vue&type=style&index=0&id=f64b36fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64b36fa",
  null
  
)

export default component.exports